// What an access point's LEDs do, in words (ADR-0332 decisions 1, 2 and 9a):
// its own setting where it holds one, else its site's, else the firmware
// default, on. One place, so the Operate fact and the Design editor say the
// same thing.
import type { components } from "../../api/schema";

export type ApLeds = components["schemas"]["AccessPointLEDs"];

// Restates ADR-0332 decisions 2 and 9a — no override inherits the site's
// setting, and a site that states none leaves the firmware default, on.
export function siteLedsWords(site: boolean | undefined): string {
  return site === undefined ? "device default (on)" : site ? "on" : "off";
}

export function apLedsWords(row: ApLeds): string {
  if (row.leds_active === undefined) return `As its site: ${siteLedsWords(row.site_leds_active)}`;
  return `${row.leds_active ? "On" : "Off"}, this access point's own setting (its site: ${siteLedsWords(row.site_leds_active)})`;
}
